const sessionLength = 59 * 60 * 1000

const returnSessionExpiryTime = () => Date.now() + sessionLength

export const logout = () => {
  const { pathname, href } = window.location

  const pathAppend =
    pathname === "/"
      ? ""
      : `?refer=${href
          .split("refer=")
          .pop()
          .replace(window.location.origin, "")}`

  window.location.href = `/logout${pathAppend}`
}

class IdleTimer {
  constructor({ store, refreshUser, storeSessionTimerInfo }) {
    this.store = store
    this.refreshUser = refreshUser
    this.storeSessionTimerInfo = storeSessionTimerInfo
    this.sessionTimer = null
    this.sessionExpiryTime = returnSessionExpiryTime()
    this.update = null
    this.start = this.start.bind(this)
    this.listenToOtherTabs = this.listenToOtherTabs.bind(this)
    this.dispatchToOtherTabs = this.dispatchToOtherTabs.bind(this)
    this.createSessionTimer = this.createSessionTimer.bind(this)
    this.refreshSession = this.refreshSession.bind(this)
    this.addListeners = this.addListeners.bind(this)
    this.removeListeners = this.removeListeners.bind(this)
    this.close = this.close.bind(this)
    this.start()
  }

  start() {
    this.refreshSession()
    this.store.subscribe(this.listenToOtherTabs)
    this.addListeners()
  }

  listenToOtherTabs() {
    const {
      sessionReducer: { sessionExpiryTime },
    } = this.store.getState()
    if (sessionExpiryTime && this.sessionExpiryTime !== sessionExpiryTime) {
      this.sessionExpiryTime = sessionExpiryTime
      this.createSessionTimer()
    }
  }

  dispatchToOtherTabs() {
    this.store.dispatch(this.storeSessionTimerInfo(this.sessionExpiryTime))
  }

  createSessionTimer() {
    if (this.sessionTimer) clearTimeout(this.sessionTimer)
    this.sessionTimer = setTimeout(logout, this.sessionExpiryTime - Date.now())
  }

  refreshSession() {
    if (!this.update) {
      this.refreshUser(this.store)
      this.sessionExpiryTime = returnSessionExpiryTime()
      this.createSessionTimer()
      this.dispatchToOtherTabs()
      this.update = setTimeout(() => {
        this.update = null
      }, 60 * 1000)
    }
  }

  addListeners() {
    window.addEventListener("click", this.refreshSession)
    window.addEventListener("scroll", this.refreshSession)
    window.addEventListener("keydown", this.refreshSession)
  }

  removeListeners() {
    window.removeEventListener("click", this.refreshSession)
    window.removeEventListener("scroll", this.refreshSession)
    window.removeEventListener("keydown", this.refreshSession)
  }

  close() {
    if (this.logoutTimer) clearTimeout(this.logoutTimer)
    if (this.tokenTimer) clearTimeout(this.tokenTimer)
    this.removeListeners()
  }
}

export default IdleTimer
